

import { useEffect, useState } from "react";
import axios from "axios";
import Layout from "../../Layout/Layout";
import FooterNew from "../../Layout/FooterNew";
import SEO from "../../SEO";

const FAQ_LIST_API =
  "https://ecom.cyberathon.com/index.php/Api/list_faq_public";

const ASK_QUESTION_API =
  "https://ecom.cyberathon.com/index.php/Api/add_faq_private";

  const BASE_URL = "https://ecom.cyberathon.com/index.php/Api"; 
const Faq = () => {
  const [faqs, setFaqs] = useState([]);
  const [openId, setOpenId] = useState(null);
  const [loading, setLoading] = useState(true);

  const [form, setForm] = useState({
    name: "",
    // email: "",
    phone:"",
    question: "",
  });

  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
 const [seoData, setSeoData] = useState({});
  /* =======================
     FETCH FAQ LIST
  ======================= */
  useEffect(() => {
    fetchFaqs();
  }, []);

  const fetchFaqs = async () => {
    try {
      const res = await axios.get(FAQ_LIST_API);
      setFaqs(res.data.faqs || []);
    } catch (error) {
      console.error("FAQ fetch error", error);
    } finally {
      setLoading(false);
    }
  };

  /* =======================
     TOGGLE FAQ
  ======================= */
  const toggleFAQ = (id) => {
    setOpenId(openId === id ? null : id);
  };

  /* =======================
     VALIDATION
  ======================= */
  const validate = () => {
    let newErrors = {};

    if (!form.name.trim()) {
      newErrors.name = "Name is required";
    } else if (!/^[A-Za-z ]{2,}$/.test(form.name)) {
      newErrors.name = "Enter a valid name";
    }

    // if (!form.email.trim()) {
    //   newErrors.email = "Email is required";
    // } else if (!/\S+@\S+\.\S+/.test(form.email)) {
    //   newErrors.email = "Invalid email address";
    // }
if (!form.phone.trim()) {
  newErrors.phone = "Phone or Email is required";
} else {
  const isEmail = /\S+@\S+\.\S+/.test(form.phone);
  const isPhone = /^[0-9]{10}$/.test(form.phone);

  if (!isEmail && !isPhone) {
    newErrors.phone = "Enter valid email or 10 digit phone";
  }
}

    if (!form.question.trim()) {
      newErrors.question = "Question is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  /* =======================
     SUBMIT QUESTION
  ======================= */
  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   if (!validate()) return;

  //   try {
  //     const res = await axios.post(ASK_QUESTION_API, form);

  //     if (res.data.status === true || res.data.status === "true") {
  //       setSubmitted(true);
  //       setForm({ name: "", email: "", question: "" });
  //       setErrors({});
  //     }
  //   } catch (error) {
  //     console.error("Submit error", error);
  //   }
  // };

  const handleSubmit = async (e) => {
  e.preventDefault();
  if (!validate()) return;

  const isEmail = /\S+@\S+\.\S+/.test(form.phone);
  const isPhone = /^[0-9]{10}$/.test(form.phone);

  const payload = {
    name: form.name,
    email: isEmail ? form.phone : "",
    phone: isPhone ? form.phone : "",
    question: form.question
  };

  try {
    const res = await axios.post(ASK_QUESTION_API, payload);

    if (res.data.status === true || res.data.status === "true") {
      setSubmitted(true);
      setForm({ name: "", phone: "", question: "" });
      setErrors({});
    }
  } catch (error) {
    console.error("Submit error", error);
  }
};

useEffect(() => {
  const fetchSeo = async () => {
    try {
      const response = await axios.post(`${BASE_URL}/get_seo_by_page`, { page_name: 'faq' });

      if (response.data.status === 'true') {
        const data = response.data.data;
        setSeoData({
          title: data.meta_title,
          description: data.meta_description,
          keywords: data.meta_keywords,
          canonical: data.canonical_url,
        });
      }
    } catch (error) {
      console.error('SEO fetch error:', error);
    }
  };

  fetchSeo();
}, []);
  return (
    <>
     <SEO
    title={seoData.title || "best cupping therapy tools ,authentic cupping supplies | shopeindia"}
    description={seoData.description || "Explore our wide collection of E-Books on programming, design, and more."}
    keywords={seoData.keywords || "ebooks, shopindia, buy ebooks, online books, programming ebooks, design ebooks"}
    canonical={seoData.canonical || "https://www.shopindia.com/ebooks"}
  />
    
    <Layout>
      <div className="faq-page container py-4">
        <h1 className="mb-4 fw-bold fs-2">Frequently Asked Questions</h1>

        {/* =======================
            FAQ LIST
        ======================= */}
        {loading ? (
          <p>Loading FAQs...</p>
        ) : faqs.length === 0 ? (
          <p>No FAQs available</p>
        ) : (
          faqs.map((faq) => (
            <div className="faq-item mb-3" key={faq.id}>
              <div
                className="faq-question d-flex justify-content-between align-items-center"
                style={{ cursor: "pointer" }}
                onClick={() => toggleFAQ(faq.id)}
              >
                <h5 className="mb-0">{faq.question}</h5>
                <span>{openId === faq.id ? "−" : "+"}</span>
              </div>

              {openId === faq.id && (
                <div className="faq-answer mt-2">
                  <p>{faq.answer}</p>
                </div>
              )}
            </div>
          ))
        )}

        {/* =======================
            ASK QUESTION FORM
        ======================= */}
        <div className="faq-ask mt-5">
          <h3>Still have a question?</h3>

          {submitted && (
            <p className="text-success">
              Your question has been submitted successfully.
            </p>
          )}

          <form onSubmit={handleSubmit} className="mt-3">
            <div className="mb-3">
              <input
                type="text"
                className="form-control"
                placeholder="Your Name"
                value={form.name}
                onChange={(e) =>
                  setForm({ ...form, name: e.target.value })
                }
              />
              {errors.name && (
                <small className="text-danger">{errors.name}</small>
              )}
            </div>

            <div className="mb-3">
              {/* <input
                type="email"
                className="form-control"
                placeholder="Your Email"
                value={form.email}
                onChange={(e) =>
                  setForm({ ...form, email: e.target.value })
                }
              />
              {errors.email && (
                <small className="text-danger">{errors.email}</small>
              )} */}
              <input
  type="text"
  className="form-control"
  placeholder="Your Phone or Email"
  value={form.phone}
  onChange={(e) =>
    setForm({ ...form, phone: e.target.value })
  }
/>
 {errors.phone && (
                <small className="text-danger">{errors.phone}</small>
              )} 
            </div>

            <div className="mb-3">
              <textarea
                className="form-control"
                placeholder="Your Question"
                rows="4"
                value={form.question}
                onChange={(e) =>
                  setForm({ ...form, question: e.target.value })
                }
              />
              {errors.question && (
                <small className="text-danger">{errors.question}</small>
              )}
            </div>

            <button type="submit" className="bg-col fw-bold">
              Submit Question
            </button>
          </form>
        </div>
      </div>

      <FooterNew />
    </Layout>
    </>
  );
};

export default Faq;
